import { render, staticRenderFns } from "./BDR2026.vue?vue&type=template&id=dec26cae&scoped=true&"
import script from "./BDR2026.vue?vue&type=script&lang=js&"
export * from "./BDR2026.vue?vue&type=script&lang=js&"
import style0 from "./BDR2026.vue?vue&type=style&index=0&id=dec26cae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dec26cae",
  null
  
)

export default component.exports